import React from 'react';
import Lottie from 'lottie-react';
import animation from 'assets/animations/loader.json';

function Loading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
      className='main-wrapper bg-white'
    >
      <span className="spinner-border text-dark" style={{ width: '2.5rem', height: '2.5rem', borderWidth: '2px' }}></span>
    </div>
  );
}

export default Loading;
